<!-- @format -->

<template>
    <div class="gst-cancellation-booking px-4 py-3 d-flex align-md-center flex-md-row flex-column">
        <div>
            <h5 class="mb-2">{{ $t('title') }}</h5>
            <p class="mb-0">{{ $t('message') }}</p>
        </div>
        <div>
            <BaseButton
                :placeholder="$t('cta')"
                color="error"
                invert
                @click="onClickCancelDo" />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BaseButton from '@core/shared/components/buttons/BaseButton';

export default {
    name: 'CancellationBooking',
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'modules.hotel.features.manageBooking._components.cancellationBooking',
    },
    components: {
        BaseButton,
    },
    computed: {
        //TODOMMH: Use for redirect to cancel flow
        ...mapGetters({
            bookingCartId: 'booking/getCartId',
            orderUuid: 'booking/getOrderUuid',
            getOrderPartnerId: 'booking/getOrderPartnerId',
            isCancelFeatureEnabled: 'booking/isCancelEnabled',
            notificationError: 'notification/error',
        }),
        computedCartId() {
            return this.bookingCartId || this.$route.params.id;
        },
    },
    methods: {
        ...mapActions({
            cancelBooking: 'cart/cancelBooking',
        }),
        async onClickCancelDo() {
            //TODOMMH:  Redirect to cancel flow but for testing action gets called here with a refresh on sucess
            if (this.isCancelFeatureEnabled) {
                const response = await this.cancelBooking({
                    orderId: this.orderUuid,
                    orderPartnerId: this.getOrderPartnerId,
                });

                if (response.success) {
                    this.$router.go(0);
                } else {
                    this.notificationError({
                        title: this.$t('messages.cancelError.title'),
                        content: this.$t('messages.cancelError.content'),
                    });
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@scssVariables';
@import '@scssMixins';

.gst-cancellation-booking {
    line-height: normal;
    background-color: theme-color('quinary');
    gap: theme-spacing(4);

    .gst-btn.v-btn.gst-btn--invert {
        height: 44px;
        border: 1px solid theme-color('error') !important;
        color: theme-color('error') !important;
        font-weight: font-weight('large');
    }
}
</style>
